import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { Banner } from "../../ui/organisms/banner";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { GetAllEntryProtocolAttachments, resetGetAllEntryProtocolAttachmentsStatus } from "../protocol/entry/slice";
import { AttachmentCADTO, CompanyFolderDetailBulkUpdateDTO } from "./dataService/dto";
import { CartellaAziendaleActiveList } from "./list/activeList";
import { CartellaAziendaleHistoryList } from "./list/historyList";
import { CompanyFolderBulkUpdate, GetAllCompanyFolders, resetCFDetailsUpdateStatus, resetGetAllCFDetailsStatus, setCartelleAziendali, setGetAllCFFiltersCustomerId, setHistoryView, setUpdateActiveCFDetailsRequest, setUpdateCFHistoryDetailsRequest } from "./slice";

export function CartellaAziendale() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const cartellaAziendaleState = useAppSelector(state => state.cartellaAziendale)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    const handleOnSave = () => {
        const activeBulk: CompanyFolderDetailBulkUpdateDTO[] = cartellaAziendaleState.activeCFDetailsUpdateRequest.map(actDet => {
            return {
                id: actDet.id,
                companyFolderUpdateDTO: {
                    deliveredOnHeadquarter: actDet.deliveredOnHeadquarter,
                    historic: actDet.historic,
                    conformityEvaluation: actDet.conformityEvaluation,
                    note: actDet.note
                }
            } as CompanyFolderDetailBulkUpdateDTO
        })
        const historicBulk: CompanyFolderDetailBulkUpdateDTO[] = cartellaAziendaleState.historyCFDetailsUpdateRequest.map(histDet => {
            return {
                id: histDet.id,
                companyFolderUpdateDTO: {
                    deliveredOnHeadquarter: histDet.deliveredOnHeadquarter,
                    historic: histDet.historic,
                    conformityEvaluation: histDet.conformityEvaluation,
                    note: histDet.note
                }
            } as CompanyFolderDetailBulkUpdateDTO
        })
        dispatch(CompanyFolderBulkUpdate([...activeBulk, ...historicBulk]))
    }

    const genericsFilterPredicate = (norm: string): boolean | undefined => {
        return (norm !== 'NORMA_BIO' && norm !== 'GLOBAL_GAP' && norm !== 'PRODUZIONE_INTEGRATA') ? true : undefined
    }

    useEffect(() => {
        dispatch(GetAllEntryProtocolAttachments({
            bio: sessionState.selected.customerNorm === 'NORMA_BIO' ? true : undefined,
            globalGap: sessionState.selected.customerNorm === 'GLOBAL_GAP' ? true : undefined,
            sqnpi: sessionState.selected.customerNorm === 'PRODUZIONE_INTEGRATA' ? true : undefined,
            generics: genericsFilterPredicate(sessionState.selected.customerNorm!),
            itemsPerPage: 0,
            page: 0
        }))

        dispatch(setGetAllCFFiltersCustomerId(sessionState.selected.customerId))

        dispatch(GetAllCompanyFolders({
            customerId: sessionState.selected.customerId!,
            itemsPerPage: 25,
            page: 1
        }))
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const companyFolderAtts: AttachmentCADTO[] = entryProtocolState.getAllEntryProtocolAttachmentsResponse.data.map(epAtt => {
                return {
                    id: epAtt.id,
                    code: epAtt.coding,
                    attachmentName: epAtt.description,
                    protocolDetailIds: []
                } as unknown as AttachmentCADTO
            })

            dispatch(setCartelleAziendali(companyFolderAtts))
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    useEffect(() => {
        if (cartellaAziendaleState.getAllCFDetailsStatus === 'successfully' &&
            cartellaAziendaleState.getAllCFDetailsResponse !== undefined
        ) {
            dispatch(resetGetAllCFDetailsStatus())
            const data = cartellaAziendaleState.getAllCFDetailsResponse

            dispatch(setUpdateActiveCFDetailsRequest(data.filter(d => d.historic === false)))
            dispatch(setUpdateCFHistoryDetailsRequest(data.filter(d => d.historic === true)))
        }
    }, [cartellaAziendaleState.getAllCFDetailsStatus])

    useEffect(() => {
        if (cartellaAziendaleState.CFDetailsUpdateStatus === 'successfully') {
            dispatch(resetCFDetailsUpdateStatus())
            dispatch(GetAllCompanyFolders({
                customerId: sessionState.selected.customerId!,
                itemsPerPage: 0,
                page: 0
            }))
        }
    }, [cartellaAziendaleState.CFDetailsUpdateStatus])

    useEffect(() => {
        if (cartellaAziendaleState.singleCFDetailCreationStatus === 'successfully' ||
            cartellaAziendaleState.singleCFDetailUpdateStatus === 'successfully' ||
            cartellaAziendaleState.companyFolderDeleteStatus === 'successfully' ||
            cartellaAziendaleState.CFDetailsUpdateStatus === 'successfully'
        ) {
            setShowSuccess(true)
        }
    }, [cartellaAziendaleState.singleCFDetailCreationStatus,
    cartellaAziendaleState.singleCFDetailUpdateStatus,
    cartellaAziendaleState.companyFolderDeleteStatus,
    cartellaAziendaleState.CFDetailsUpdateStatus
    ])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [showSuccess]);


    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.CARTELLA_AZIENDALE}
                breadcrumbItems={['Cartella Aziendale']}
                noPaddingLat
                headerLabel="Cartella Aziendale"
                headerChildren={
                    <div className="flex items-center h-[100%] w-[100%] justify-end">
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Salva"
                            color={"orange"}
                            onClick={handleOnSave}
                        />
                    </div>
                }
            >
                <div className="px-6 py-5">
                    {/* <div className="pb-5">
                        <ClientBanner
                            region={sessionState.selected.customerRegion!}
                            client={sessionState.selected.customerName!}
                            code={sessionState.selected.customerCode!}
                            activity={sessionState.selected.customerActivities ? `${sessionState.selected.customerActivities.map(act => optionsFormatter(act, attivita_bio))}` : undefined}
                            norm={optionsFormatter(sessionState.selected.customerNorm!, normativa)!}
                        />
                    </div> */}

                    <div className="mb-5 rounded-[14px] border border-[#E5E7EB] bg-white px-4 py-3 shadow-sm">
                        <div className="flex flex-wrap items-center justify-between gap-3">
                            <div>
                                <h3 className="text-[15px] font-semibold text-[#1F2937]">Gestione protocolli cartella</h3>
                                <p className="text-[13px] text-[#6B7280]">
                                    {sessionState.selected.customerName || 'Cliente selezionato'}
                                </p>
                            </div>
                            <ButtonComponent
                                variant="outline"
                                color="blue"
                                iconPosition="off"
                                size="md"
                                label={cartellaAziendaleState.historyView ? 'Vedi Attivo' : 'Vedi Storico'}
                                onClick={() => dispatch(setHistoryView(!cartellaAziendaleState.historyView))}
                            />
                        </div>
                    </div>
                    {
                        (showSuccess) &&
                        <div className="mb-4 rounded-[12px] border border-[#86EFAC] bg-[#ECFDF3] px-5 py-4 text-left">
                            <span className="fieldsetTitle block text-[14px] font-semibold text-[#166534]">
                                Dati salvati correttamente.
                            </span>
                        </div>
                    }

                    <div className="rounded-[16px] border border-[#E5E7EB] bg-[#F9FAFB] p-4 shadow-sm">
                        <div className="table-head-ca flex uppercase text-text-sm">
                            <div className="basis-[5%]"></div>
                            <div className="basis-[25%]">Riferimento protocolli</div>
                            <div className="basis-[40%] max-w-[1000px]">Note</div>
                            <div className="basis-[15%] text-center">Storico</div>
                            <div className="basis-[15%] text-center">Valutazione conformita</div>
                        </div>

                        <div className="mt-3">
                            {
                                cartellaAziendaleState.historyView ?
                                    <CartellaAziendaleHistoryList /> :
                                    <CartellaAziendaleActiveList />
                            }
                        </div>
                    </div>

                </div>
            </Layout>
        )
    }

    return (
        <Layout
            menuItem={MenuItems.CARTELLA_AZIENDALE}
            breadcrumbItems={['Cartella Aziendale']}
            noPaddingLat
            headerLabel={"Cartella Aziendale"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}